import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { errorMessage, successMessage } from '@api/messages';
import { changeFileSetStatus } from '../api';
import { UploadNewStatus } from '../dto/UploadNewStatus';

export default function usePostUploadStatus(
  triggerTableRefresh: (uploadsTableRefresh: boolean) => void
) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (uploadNewStatus: UploadNewStatus) => changeFileSetStatus(uploadNewStatus),
    {
      onSuccess: (_, uploadNewStatus) => {
        queryClient.invalidateQueries('comments');
        queryClient.invalidateQueries('commentsCount');
        queryClient.invalidateQueries('getUploadById');
        successMessage({
          title: t('success.upload.status.change', {
            uploadStatus: t(uploadNewStatus.status.message),
          }),
          message: null,
        });
        triggerTableRefresh(true);
      },
      onError: (error, uploadNewStatus) => {
        errorMessage({
          title: t('error.upload.status.change', {
            uploadStatus: t(uploadNewStatus.status.message),
          }),
          message: null,
          error,
        });
      },
    }
  );
  return mutate;
}
